import { render, staticRenderFns } from "./ComCodeView.vue?vue&type=template&id=023660fe&scoped=true"
import script from "./ComCodeView.vue?vue&type=script&lang=js"
export * from "./ComCodeView.vue?vue&type=script&lang=js"
import style0 from "./ComCodeView.vue?vue&type=style&index=0&id=023660fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023660fe",
  null
  
)

export default component.exports